
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/offcanvas",
      function () {
        return require("private-next-pages/components/offcanvas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/offcanvas"])
      });
    }
  